<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissible]="false"
  styleClass="_drawer"
>
  <router-outlet
    name="sidebar"
    (activate)="drawerVisible.set(true)"
    (deactivate)="drawerVisible.set(false)"
  ></router-outlet>
</p-drawer>

<div class="_layout">
  <div class="_notification-bar">
    <dt-notification-bar></dt-notification-bar>
  </div>
  <div class="_sidebar">
    <dt-workspace-sidebar></dt-workspace-sidebar>
  </div>
  <main class="_main-content">
    <dt-toolbar></dt-toolbar>
    <router-outlet></router-outlet>
  </main>
</div>
